import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';

import { GCADA_CONFIG } from '@GCADA/services/config.service';

@NgModule()
export class GCADAModule
{
    constructor(@Optional() @SkipSelf() parentModule: GCADAModule)
    {
        if ( parentModule )
        {
            throw new Error('GCADAModule is already loaded. Import it in the AppModule only!');
        }
    }

    static forRoot(config): ModuleWithProviders
    {
        return {
            ngModule : GCADAModule,
            providers: [
                {
                    provide : GCADA_CONFIG,
                    useValue: config
                }
            ]
        };
    }
}
